import React from 'react';

const ViewGrid = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.244141"
      y="0.707031"
      width="6.48718"
      height="6.48718"
      rx="2.31685"
      fill="url(#paint0_linear_8762_11967)"
    />
    <rect
      x="0.244141"
      y="9.97363"
      width="6.48718"
      height="6.48718"
      rx="2.31685"
      fill="url(#paint1_linear_8762_11967)"
    />
    <rect
      x="9.51172"
      y="0.707031"
      width="6.48718"
      height="6.48718"
      rx="2.31685"
      fill="url(#paint2_linear_8762_11967)"
    />
    <rect
      x="9.51172"
      y="9.97363"
      width="6.48718"
      height="6.48718"
      rx="2.31685"
      fill="url(#paint3_linear_8762_11967)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8762_11967"
        x1="-2.10422"
        y1="-2.03886"
        x2="8.04796"
        y2="5.32046"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2CA8D3" />
        <stop offset="0.485" stopColor="#1AE9BA" />
        <stop offset="1" stopColor="#79EE5D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8762_11967"
        x1="-2.10422"
        y1="7.22774"
        x2="8.04796"
        y2="14.5871"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2CA8D3" />
        <stop offset="0.485" stopColor="#1AE9BA" />
        <stop offset="1" stopColor="#79EE5D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8762_11967"
        x1="7.16336"
        y1="-2.03886"
        x2="17.3155"
        y2="5.32046"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2CA8D3" />
        <stop offset="0.485" stopColor="#1AE9BA" />
        <stop offset="1" stopColor="#79EE5D" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8762_11967"
        x1="7.16336"
        y1="7.22774"
        x2="17.3155"
        y2="14.5871"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2CA8D3" />
        <stop offset="0.485" stopColor="#1AE9BA" />
        <stop offset="1" stopColor="#79EE5D" />
      </linearGradient>
    </defs>
  </svg>
);

export default ViewGrid;
